<template>
  <div>
    <div class="welcome-section px-6 2xl:px-24 py-32 text-slider flex md:justify-between bg-white full xl:mr-16 mr-6 -mt-32 items-center gap-10 xl:gap-40 flex-col xl:flex-row">

      <div class="flex flex-col w-full xl:w-2/4 flex-wrap order-2 xl:order-1">
        <img src="/products/nnp-vpn-logo-typo.svg" class="w-64 mb-14 xl:block hidden">
        <span class="h4 mb-8">{{ $t('NNP_VPN_WELCOME_PHRASE') }}</span>
        <span class="h6 mb-4">{{ $t('NNP_VPN_WELCOME_DESC') }}</span>

        <div class="my-8 block">
          <a href="#plans">
            <button class="fira-ui-btn primary">
              {{ $t('BUY_NOW') }}
            </button>
          </a>
        </div>
      </div>

      <div class="xl:flex-1 flex 2xl:justify-end w-full order-1 xl:order-2">
        <img src="/illustrations/vpn/multi-device-protection.svg" alt="" class="vpn_multi_device_protection_illustration">
      </div>
    </div>

    <!-- Highlights -->

    <div class="px-12 2xl:px-32 md:py-32 py-16 text-slider flex justify-between bg-gray-200 w-full md:ml-24 ml-12 resources-highlights -mt-28">
      <ul class="flex w-full gap-10 lg:gap-14 flex-col lg:flex-row lg:items-top">
        <li class="pb-4 flex flex-1 flex-col border-b border-black lg:border-b-0">
          <span class="h6 mb-4">{{ $t('HIGH_SPEEDS') }}</span>
          <span class="">{{ $t('HIGH_SPEEDS_VPN_DESC') }}</span>
        </li>
        <li class="hidden lg:flex separator"></li>
        <li class="pb-4 flex flex-1 flex-col border-b border-black lg:border-b-0">
          <span class="h6 mb-4">{{ $t('ZERO_RECORDS_POLICY') }}</span>
          <span class="">{{ $t('ZERO_RECORDS_POLICY_DESC') }}</span>
        </li>
        <div class="hidden lg:flex separator"></div>
        <li class="pb-4 flex flex-1 flex-col border-b border-black lg:border-b-0">
          <span class="h6 mb-4">{{ $t('31_DAY_MONEY_BACK') }}</span>
          <span class="">{{ $t('31_DAY_MONEY_BACK_DESC') }}</span>
        </li>
      </ul>
    </div>


    <div class="px-6 2xl:px-24 md:py-60 py-32  text-slider flex justify-between flex-col md:flex-row">
      <span class="h1 -mt-8 mr-4 text-primary">"</span>
      <span class="h4">
        {{ $t('NNP_VPN_HIGHLIGHTS_EFFECT_PHRASE') }}
      </span>
    </div>


    <div class="px-6 md:px-12 2xl:px-24 py-40 text-slider flex justify-between flex-wrap gap-32 bg-gray-200">
      <div class="max-w-screen-md w-full">
        <h3 class="mb-9">
          {{ $t('SAFE_UNLIMITED_BROWSING') }}
        </h3>
        <span>
          {{ $t('SAFE_UNLIMITED_BROWSING_DESC') }}
        </span>
      </div>

      <!--  -->
      <ul class="private-limitless flex-col md:flex-row">
        <li class="p-12 bg-white flex flex-col justify-end">
          <img src="/illustrations/vpn/secure-connection-icon.svg" alt="" class="w-32 2xl:my-10 my-5">
          <div>
            <h6>{{ $t('SECURE_CONNECTION') }}</h6>
            <span>
              {{ $t('VPN_SECURE_CONNECTION_DESC') }}
            </span>
          </div>
        </li>
        <li class="p-12 bg-white flex flex-col justify-end">
          <img src="/illustrations/vpn/many-networks-icon.svg" alt="" class="w-32 2xl:my-10 my-5">
          <div>
            <h6>{{ $t('GLOBAL_NETWORK') }}</h6>
            <span>
              {{ $t('VPN_GLOBAL_NETWORK_DESC') }}
            </span>
          </div>
        </li>
      </ul>

    </div>
   
    <NextGenSectionsTextSliders
      :title="$t('MORE_THAN_JUST_A_VPN')"
      :words1="[$t('SPLIT_TUNNELING'), $t('INTERNET_KILL_SWITCH'), $t('256_BIT_ENCRYPTION'), $t('WIREGUARD'), $t('OBFUSCATED_SERVER')]"
      :words2="[$t('AD_TRACKER_BLOCK'), $t('6000_SERVERS'), $t('STREAM_WITHOUT_LIMITS'), $t('80_LOCATIONS'), $t('FASTEST_SERVERS')]"
      :words3="[$t('5_DEVICES_SUPPORTED'), $t('SPLIT_TUNNELING'), $t('INTERNET_KILL_SWITCH'), $t('256_BIT_ENCRYPTION'), $t('WIREGUARD')]"
    >

    </NextGenSectionsTextSliders>

    <NextGenSectionsGetApps
      :items="[
        { platform: 'windows', url: 'https://play.google.com/store/apps/details?id=com.nuinalp.vpn', soon: true },
        { platform: 'linux', url: 'https://play.google.com/store/apps/details?id=com.nuinalp.vpn', soon: true },
        { platform: 'macos', url: 'https://play.google.com/store/apps/details?id=com.nuinalp.vpn', soon: true },
        { platform: 'android', url: 'https://play.google.com/store/apps/details?id=com.nuinalp.vpn' },
        { platform: 'ios', url: 'https://play.google.com/store/apps/details?id=com.nuinalp.vpn', soon: true },
      ]"
    >

    </NextGenSectionsGetApps>

    <NextGenSectionsPlans
      @change="() => null"
      :plans="locale !== 'pt-br' ? [] : [
        { name: 'Mensal', bill_cycle: 'month', bill_interval: 1, value: 20.40 * 100, net_value: 20.40 * 100, discount: 0, discount_cycle: 0, features: vpnPlanFeatures, externalBuyAction: gPlayUrl },
        { name: '6 Meses', bill_cycle: 'month', bill_interval: 6, value: 91.40 * 100, net_value: 91.40 * 100, discount: 0, discount_cycle: 0, features: vpnPlanFeatures, externalBuyAction: gPlayUrl },
        { name: 'Anual', bill_cycle: 'year', bill_interval: 1, value: 169.9 * 100, net_value: 169.9 * 100, discount: 0, discount_cycle: 0, is_recommended: true, is_popular: true, features: vpnPlanFeatures, externalBuyAction: gPlayUrl },
        ]">

      <div v-if="locale !== 'pt-br'" class="pb-8 why_use_items block w-full mt-16">
        <span class="h6 text-6xl block py-16">
          {{ $t('VPN_NOT_AVAILABLE') }}
        </span>
      </div>

    </NextGenSectionsPlans>



    <SectionsFaqs product-slug="nuinalp-vpn" />
  </div>
</template>

<script lang="ts" setup>
// Types
import type { IVariantsResponse, IVariantRoot } from '@nuinalp/global-website-sdk-js/types';

// ---------------------------------------
// Hooks
// ---------------------------------------
definePageMeta({
});

const { $config, $signRoute } = useNuxtApp();
const { t, locale } = useI18n();
const selectedVariant = ref<Partial<IVariantRoot>>({});

const gPlayUrl = $config.public.NNP_GPLAY_VPN_URL;

const vpnPlanFeatures = computed(() => [t('SPLIT_TUNNELING'), t('INTERNET_KILL_SWITCH'), t('5_DEVICES_SUPPORTED'), t('31_DAY_MONEY_BACK'), t('256_BIT_ENCRYPTION'), t('6000_SERVERS'), t('SAFE_UNLIMITED_BROWSING'), t('ZERO_RECORDS_POLICY')])

// ---------------------------------------
// Methods
// ---------------------------------------

function getVariants() {
  return $fetch<IVariantsResponse>('/api/products/nnp_vpn/variants?' + new URLSearchParams({ country: countryByLocale[<keyof typeof countryByLocale>locale.value] }).toString())
}

function onSelectedPlan(variant: IVariantRoot) {
  selectedVariant.value = variant;
  $signRoute({ goToCheckout: true, product_slug: 'nnp_vpn', variant_id: variant.id });
}


// ---------------------------------------
// Meta
// ---------------------------------------

useHead({
  title: t('vpn_title') as string,
});
</script>

<style lang="scss" scoped>
/*
* Mixes
*/
@import '@nuiverse/core/src/style/_utils';
@import '@nuiverse/core/src/style/mixins/_breakpoints';

/**
* -------------------------------
* Mobile
* -------------------------------
*/

@media screen and (max-width: 480px) {
  .galery {
    padding: 20px;
  }
}

@include sm() {
  .card {
    margin-bottom: $space-md;
    margin-right: 0 !important;
    width: 100%;
  }

  .card-blue {
    margin-bottom: $space-md;
    margin-right: 0 !important;
    width: 100%;
  }
}

.private-limitless {
  display: flex;
  gap: 36px;
  
  li {
    width: 100%;
    max-width: 480px;
  }
}

.resources-highlights {
  width: calc(100% - 3rem);

  .separator {
    width: 1px;
    height: 80%;
    background-color: #000;
  }
}

.welcome-section {
  min-height: 950px;
}

.vpn_multi_device_protection_illustration {
  width: 90%;
  max-width: 450px;
}


@media (screen(lg)) {
  .resources-highlights {
    width: calc(100% - 6rem);
  }

  .private-limitless {
    li {
      max-width: 380px;
    }
  }
}


@media (screen(2xl)) {
  .vpn_multi_device_protection_illustration {
    width: 90%;
    max-width: 850px;
  }
}


@media (screen(2k)) {

.private-limitless {
  li {
      max-width: 480px;
    }
  }
}
</style>
